export default function WarrantyValue() {
  return (
    <section className="tw-bg-black tw-text-white">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-h-[520px]">
        {/* Text */}
        <div className="tw-flex tw-items-center tw-px-6 tw-py-16 md:tw-py-0 md:tw-pl-[9%] md:tw-pr-10">
          <div>
            {/* line breaks follow the design on lg+; text wraps freely below */}
            <h2 className="tw-text-4xl lg:tw-text-[52px] tw-font-semibold tw-leading-[1.2] lg:[&>span]:tw-block lg:[&>span]:tw-whitespace-nowrap">
              <span>You depend on your </span>
              <span>product, keep it safe for </span>
              <span>the long-haul.</span>
            </h2>

            <p className="tw-mt-8 tw-text-sm lg:tw-text-base tw-leading-7 tw-text-white/85 xl:[&>span]:tw-block xl:[&>span]:tw-whitespace-nowrap">
              <span>Peace of mind shouldn't end when your warranty does. Thanks to the IZI </span>
              <span>Extended Warranty Plan, it doesn't have to. You'll enjoy protection beyond </span>
              <span>your manufacturer's warranty.</span>
            </p>
          </div>
        </div>

        {/* Image */}
        <div className="tw-relative tw-h-96 md:tw-h-full">
          <img
            src="/izicart/product-ew.jpg"
            alt="IZI drone in flight"
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
          />
        </div>
      </div>
    </section>
  );
}
